module.exports = __webpack_public_path__ + "img/ranking-3.870b561e.svg";